import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { catchError, map, of, tap, throwError } from 'rxjs';
import { UserDTO } from '../models/UserDTO.model';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { UserRequestDTO } from '../shared/models/UserRequestDto';
import { PlanByUserDTO } from '../models/PlanByUserDTO.model';
import { SimpleRequestDTO } from '../shared/models/SimpleRequest';
import { UserManagementDTO } from '../models/UserManagementDTO.model';
import { CustomerPlanSummaryDTO } from '../models/CustomerPlanSummaryDTO.model';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { UserPlanHistoryRequest } from '../models/UserplanHistory/UserPlanHistoryRequest';
import { UserPlanHistoryResponse } from '../models/UserplanHistory/UserPlanHistoryResponse';
import { DeviceDTO } from '../models/DeviceDTO.model';
import { revertTransferDto } from '../models/inventory/revertTransferDto';
import { PlanDeviceSummaryDTO } from '../models/PlanDeviceSummaryDTO.model';
import { TDeviceUsageDTO } from '../models/TDeviceUsageDTO.model';
import { ResponseBase } from '../models/ResponseBase';
import { FindCustomerPlanResultDTO } from '../models/FindCustomerPlanResultDTO.model';
import { DeviceDetailDTO } from '../models/DeviceDetailDTO.model';
import { GetCustomerDevicesResultDTO } from '../models/GetCustomerDevicesResultDTO';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private httpService: HttpService) { }

  getMastersById(data: MasterdataRequestDTO) {
    return this.httpService.getMastersById(data).pipe(
      tap((data) => {
      })
    );
  }

  saveCustomer(customer: UserDTO) {
    return this.httpService.saveCustomer(customer).pipe(
      tap((data) => {
      })
    );
  }

  saveCustomerUser(customer: UserDTO) {
    return this.httpService.saveCustomerUser(customer).pipe(
      tap((data) => {
      })
    );
  }

  createUserStaff(customer: UserDTO) {
    return this.httpService.createUserStaff(customer).pipe(
      tap((data) => {
      })
    );
  }

  createDistributorCustomer(customer: UserDTO) {
    return this.httpService.createDistributorCustomer(customer).pipe(
      tap((data) => {
      })
    );
  }

  getCurrentUser() {
    return this.httpService.getCurrentUser().pipe(
      tap((data) => {
      })
    );
  }

  getListCustomers() {
    return this.httpService.getListCustomers().pipe(
      tap((data) => {
      })
    );
  }

  GetCustomersForTransfer() {
    return this.httpService.post<UserDTO[]>(ApiRoutesEnum.GetCustomersForTransfer, {}).pipe(
      tap((data) => {
      })
    );
  }

   GetCustomersWithTranfers() {
    return this.httpService.post<revertTransferDto>(ApiRoutesEnum.GetCustomersWithTranfers, {}).pipe(
      tap((data) => {
      })
    );
  }

  GetUserPlanActiveDevices(userPlanId : string) {
    return this.httpService.post<DeviceDTO[]>(ApiRoutesEnum.GetUserPlanActiveDevices + userPlanId, {}).pipe(
      tap((data) => {
      })
    );
  }

  getPercentageAlertByUser() {
    return this.httpService.getPercentageAlertByUser().pipe(
      tap((data) => {
      })
    );
  }

  getListUsersManagement() {
    return this.httpService.getListUsersManagement().pipe(
      tap((data) => {
        
      })
    );
  }

  updateCustomerStatus(customer: UserDTO) {
    return this.httpService.updateCustomerStatus(customer).pipe(
      tap((data) => {
      })
    );
  }

  updateUserPercentageAlert(customer: CustomerPlanSummaryDTO[]) {
    return this.httpService.updateUserPercentageAlert(customer).pipe(
      tap((data) => {
      })
    );
  }

  UpdateSendThresholdConsumptionAlert(request: CustomerPlanSummaryDTO) {
    return this.httpService.post<ResponseBase>( ApiRoutesEnum.UpdateSendThresholdConsumptionAlert,request).pipe(
      tap((data) => {
      })
    );
  }
  
  updateCustomer(customer: UserDTO) {
    return this.httpService.updateCustomer(customer).pipe(
      tap((data) => {
      })
    );
  }

  getCustomerById(customer: UserRequestDTO) {
    return this.httpService.getUserById(customer).pipe(
      tap((data) => {
      })
    );
  }

   getUserByOriginalId(id: number) {
    return this.httpService.get<UserDTO>(ApiRoutesEnum.GetUserByOriginalId + id).pipe(
      tap((data) => {
      })
    );
  }

  getPlansByUserId(customer: UserRequestDTO) {
    return this.httpService.getPlansByUserId(customer).pipe(
      tap((data) => {
      })
    );
  }

  getListUsersOfCustomer(customer: UserRequestDTO) {
    return this.httpService.getListUsersOfCustomer(customer).pipe(
      tap((data) => {
      })
    );
  }

  getListUsersOfStaff(customer: UserRequestDTO) {
    return this.httpService.getListUsersOfStaff(customer).pipe(
      tap((data) => {
      })
    );
  }

  getListCustomersOfDistributor(customer: UserRequestDTO) {
    return this.httpService.getListCustomersOfDistributor(customer).pipe(
      tap((data) => {
      })
    );
  }
  
  updateUserPlanStatus(userPlanDevDTO: PlanByUserDTO) {
    return this.httpService.updateUserPlanStatus(userPlanDevDTO).pipe(
      tap((data) => {
      })
    );
  }

  updatePassword(customer: UserDTO) {
    return this.httpService.updatePassword(customer).pipe(
      tap((data) => {
      })
    );
  }

  clearCustomersPartner(request: SimpleRequestDTO) {
    return this.httpService.clearCustomersPartner(request).pipe(
      tap((data) => {
      })
    );
  } 

  /*
  getUserSummary(request: SimpleRequestDTO) {
    return this.httpService.getUserSummary(request).pipe(
      tap((data) => {
      })
    );
  }
  */

  getDevicesNotYetAssignedToAPlan(id?: number | 0) {

    if (id === null || id === undefined) {
      id = 0; // Default value if id is null or undefined
    }

    return this.httpService.get<DeviceDTO[]>( ApiRoutesEnum.getDevicesNotYetAssignedToAPlan,{ id: id }).pipe(
      tap((data) => {
      })
    );
  }

  saveUserManagement(user: UserManagementDTO) {
    return this.httpService.saveUserManagement(user).pipe(
      tap((data) => {
      })
    );
  }

  updateUserManagement(user: UserManagementDTO) {
    return this.httpService.updateUserManagement(user).pipe(
      tap((data) => {
      })
    );
  }

  exportCustomersListToExcel(){
    return this.httpService.exportCustomersListToExcel().pipe(
      tap((data) => {
      })
    );
  }

  exportToExcelListCustomerPlans(customer: UserRequestDTO) { 
    return this.httpService.exportToExcelListCustomerPlans(customer).pipe(
      tap((data) => {
      })
    );
  }

  exportToExcelListUsersManagement(){
    return this.httpService.exportToExcelListUsersManagement().pipe(
      tap((data) => {
      })
    );
  }

  GetUserPlanHistory(request: UserPlanHistoryRequest) {
    return this.httpService.get<UserPlanHistoryResponse>(ApiRoutesEnum.GetUserPlanHistory ,request).pipe(
      tap((data) => {
      })
    );
  }

  getCustomerPlans(userId?: number) {
    return this.httpService.get<CustomerPlanSummaryDTO[]>(ApiRoutesEnum.getCustomerPlans + userId).pipe(
      tap((data) => {
      })
    );
  }

  getCustomerPlanByUserPlanId(userPlanId?: number) {
    return this.httpService.get<PlanDeviceSummaryDTO[]>(ApiRoutesEnum.getCustomerPlanByUserPlanId + userPlanId).pipe(
      tap((data) => {
      })
    );
  }

  getAllUsagesByUserPlanId(userPlanId?: number) {
    return this.httpService.get<TDeviceUsageDTO>(ApiRoutesEnum.getAllUsagesByUserPlanId + userPlanId).pipe(
      tap((data) => {
      })
    );
  }

  /**
   * Поиск плана клиента по полному совпадению ICCID. Если план не найден, возвращает null.
   */
  findCustomerPlanByICCID(iccid: string) {
    return this.httpService.get<FindCustomerPlanResultDTO>(ApiRoutesEnum.FindCustomerPlanByICCID + iccid, {}).pipe(
      catchError(error => error.status === 404 ? of(null) : throwError(() => error))
    );
  }

  /**
   * Поиск планов клиента по частичному совпадению ICCID, IMEI, Username и UserName2.
   * Дополнительно можно указать customerId для ограничения поиска планов конкретного клиента.
   * Если план не найден, возвращает пустой массив.
   */
  findCustomerPlans(searchValue: string, customerId?: number) {
    return this.httpService.get<FindCustomerPlanResultDTO[]>(ApiRoutesEnum.FindCustomerPlans + searchValue, {customerId});
  }

  getCustomerDevices(customerId: number) {
    return this.httpService.get<GetCustomerDevicesResultDTO[]>(ApiRoutesEnum.GetCustomerDevices + customerId);
  }

  getDeviceConsumptions(userPlanId: number, deviceId?: number) {
    return this.httpService.get<number>(ApiRoutesEnum.GetDeviceConsumptions + userPlanId + '/' + (deviceId || ''), { noLoader: 1 });
  }

}
